import { Box, Flex, Typography } from "flux";
import BackLink from "../../../../../apps/web/src/components/creative-review/back-link";

interface TitleBarProps {
  backLinkText?: string;
  backLinkPath?: string;
  title?: string;
  titleVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  children?: React.ReactNode;
}

export const TitleBarHeight = 64;

const TitleBar: React.FC<TitleBarProps> = ({ backLinkText, backLinkPath, title, titleVariant = "h1", children }) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      zIndex={15}
      px="16px"
      borderBottom={title ? "1px solid" : "none"}
      borderColor="divider"
      bgcolor={title ? "background.default" : "transparent"}
      sx={{
        position: "sticky",
        top: 0,
        "@media print": {
          position: "static !important"
        }
      }}
    >
      <Box>
        {backLinkText && (
          <BackLink to={backLinkPath} data-action-name="page back link">
            {backLinkText}
          </BackLink>
        )}
      </Box>
      {title && (
        <Typography variant={titleVariant} color="textPrimary">
          {title}
        </Typography>
      )}
      <Flex height={TitleBarHeight} alignItems="center">
        {children}
      </Flex>
    </Flex>
  );
};

export default TitleBar;
